/**
 * Liste explicite des colonnes lisibles de `public.profiles` pour un utilisateur
 * authentifié. Le champ `phone` est volontairement exclu : il n'est plus
 * accessible via SELECT direct depuis la migration de sécurité « protection
 * des numéros de téléphone ». Pour récupérer un numéro, utiliser les RPC :
 *   - `get_my_phone()`           — numéro du compte connecté
 *   - `get_user_phone(_user_id)` — numéro d'un autre utilisateur, seulement
 *                                  si admin / propriétaire / réservation
 *                                  confirmée commune
 *   - `admin_list_user_phones()` — admin uniquement
 */
export const PROFILE_PUBLIC_COLUMNS = [
  "id",
  "user_id",
  "full_name",
  "avatar_url",
  "bio",
  "city",
  "postal_code",
  // "street_address" retiré : lisible uniquement par le propriétaire via RPC get_my_private_profile
  "country",
  "country_code",

  "hourly_rate",

  "experience",
  "diplomas",
  "is_available",
  "subscription_active",
  "created_at",
  "updated_at",
  "latitude",
  "longitude",
  "available_days",
  "care_at_pro_home",
  "care_at_parent_home",
  "identity_verified",
  "suspended_at",
  "suspension_reason",
  "pro_category",
  "care_outdoor",
  "service_radius",
  "services_offered",
  "avail_morning_active",
  "avail_morning_start",
  "avail_morning_end",
  "avail_midday_active",
  "avail_midday_start",
  "avail_midday_end",
  "avail_afternoon_active",
  "avail_afternoon_start",
  "avail_afternoon_end",
  "avail_evening_active",
  "avail_evening_start",
  "avail_evening_end",
  "avail_night_active",
  "avail_night_start",
  "avail_night_end",
  "service_school_dropoff",
  "service_school_pickup",
  "service_meal",
  "service_snack",
  "service_park_outdoor",
  "service_school_activity",
  "service_extracurricular",
  "service_sport_activity",
  "service_other_activity",
  "instant_available",
  "instant_available_until",
  "instant_last_renewed_at",
  "warning_count",
  "suspended_until",
  "service_cleaning",
  "service_bath",
  "service_homework",
  "service_pet_walk",
  "accepts_stripe",
  "accepts_cash",
  "accepts_paypal",
  // "paypal_identifier" retiré : lisible uniquement par le propriétaire via
  // get_my_private_profile(), ou par un parent réservant via
  // get_pro_paypal_identifier(_pro_id).
].join(",");

